import { render } from "./Produk.vue?vue&type=template&id=5f080459"
import script from "./Produk.vue?vue&type=script&lang=js"
export * from "./Produk.vue?vue&type=script&lang=js"

import "./Produk.vue?vue&type=style&index=0&id=5f080459&lang=css"
script.render = render

export default script